module.exports = __webpack_public_path__ + "static/media/barba.83096f63.jpeg";